// Slideshow

// Flickity
var Flickity = require('flickity')
import 'flickity/css/flickity.css'


// Flickity is instanciated in the HTML



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/_slideshow.js